// AOS Animations JS Start Here

AOS.init({
    once: true,
});
AOS.refresh();

// AOS Animations JS End here

// Hero Slider Start here

$('#Hero-carousel').owlCarousel({
    center: true,
    loop: true,
    margin: 100,
    dots: false,
    autoplay: true,
    smartSpeed: 1000,
    nav: false,
    autoWidth: true,
    responsive:{
        0:{
            items:1,
            autoWidth: false,
        },
        700:{
            items:2,
        },
        992:{
            items:2,
        },
        1300:{
            items:3,
        }
    }
});

// Hero Slider End here

// Dark Mode JS Start Here

$(function () {
    const myBodyone = document.getElementById('mode');
    const myBtnone = document.getElementById('dark-btn1');  

	myBtnone.addEventListener('click', () => {
        myBodyone.classList.toggle("mode");
    });
});

$(function () {
    const myBody = document.getElementById('mode');
    const myBtn = document.getElementById('dark-btn');  

	myBtn.addEventListener('click', () => {
        myBody.classList.toggle("mode");
    });
});

// Dark Mode JS End Here

// Liquidity JS Click Events Start Here

$(function () {
    const myToggle = document.getElementById('add-liquidity');
    const myToggle2 = document.getElementById('import-liquidity');
    const myRowone = document.getElementById('row-1');
    const myRowtwo = document.getElementById('row-2');
    const myRowthree = document.getElementById('row-3');
    const myclose = document.getElementById('icon-back');
    const myclose2 = document.getElementById('icon-back2');  

	myToggle.addEventListener('click', () => {
        myRowone.style.display = 'none';
        myRowtwo.style.display = 'flex';
        myRowthree.style.display = 'none';
    });
    myToggle2.addEventListener('click', () => {
        myRowone.style.display = 'none';
        myRowtwo.style.display = 'none';
        myRowthree.style.display = 'flex';
    });
    myclose.addEventListener('click', () => {
        myRowone.style.display = 'flex';
        myRowtwo.style.display = 'none';
        myRowthree.style.display = 'none';
    });
    myclose2.addEventListener('click', () => {
        myRowone.style.display = 'flex';
        myRowtwo.style.display = 'none';
        myRowthree.style.display = 'none';
    });
});

$(function () {
    const stToggle = document.getElementById('st-toggle-otr');
    const stCircle = document.getElementById('st-toggle');
    const rowMilk = document.getElementById('row-milk1'); 

	stToggle.addEventListener('click', () => {
        stCircle.classList.toggle("stack-active");
        rowMilk.classList.toggle("row-none");
    });
});


$(function () {
    const seeToggle1 = document.getElementById('see-detail1');
    const seeToggle2 = document.getElementById('see-detail2');
    const seeToggle3 = document.getElementById('see-detail3');
    const seeToggle4 = document.getElementById('see-detail4');
    const seeToggle5 = document.getElementById('see-detail5');
    const seeToggle6 = document.getElementById('see-detail6');
    const ulToggle1 = document.getElementById('ul-detail1');
    const ulToggle2 = document.getElementById('ul-detail2');
    const ulToggle3 = document.getElementById('ul-detail3');
    const ulToggle4 = document.getElementById('ul-detail4');
    const ulToggle5 = document.getElementById('ul-detail5');
    const ulToggle6 = document.getElementById('ul-detail6');

	seeToggle1.addEventListener('click', () => {
        ulToggle1.classList.toggle("ul-active");
    });
    seeToggle2.addEventListener('click', () => {
        ulToggle2.classList.toggle("ul-active");
    });
    seeToggle3.addEventListener('click', () => {
        ulToggle3.classList.toggle("ul-active");
    });
    seeToggle4.addEventListener('click', () => {
        ulToggle4.classList.toggle("ul-active");
    });
    seeToggle5.addEventListener('click', () => {
        ulToggle5.classList.toggle("ul-active");
    });
    seeToggle6.addEventListener('click', () => {
        ulToggle6.classList.toggle("ul-active");
    });
});

// Navbar Dots Click Event Start Here

$(function () {
    const myDots = document.getElementById('dots');
    const myDrop = document.getElementById('drop-event');  

	myDots.addEventListener('click', () => {
        myDrop.classList.toggle("show");
    });
});

// Navbar Dots Click Event End Here

// Liquidity JS Click Events End Here

//Overlay Navbar Start Here

$(document).ready(function(){
    $(".burger-icon-otr").click(function(){
        $(".overlay-content").addClass("overlay-open");
    });
    $(".close-icon-otr").click(function(){
        $(".overlay-content").removeClass("overlay-open");
    });
});

//Overlay Navbar End Here

//Coming Soon Start Here

var Usmanali = document.getElementsByClassName('usman');

// $('#clock').countdown('2021/10/12 21:07:00')
// .on('update.countdown', function(event) {
//   var format = '%H:%M:%S';
//   if(event.offset.totalDays > 0) {
//     format = '%-d day%!d ' + format;
//   }
//   if(event.offset.weeks > 0) {
//     format = '%-w week%!w ' + format;
//   }
//   $(this).html(event.strftime(format));
// })
// .on('finish.countdown', function(event) {
//     $(this).addClass('block').parent().addClass('disabled');
//     $('.usman').addClass('none');
// });

//Coming Soon End Here






